import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const ServicesExpertiseSection = () => {
  const { language } = useLanguage();
  
  const expertiseAreas = [
    {
      title: {
        fr: 'Instrumentation Pétrole, Gaz et Industrie',
        ar: 'أجهزة قياس النفط والغاز والصناعة'
      },
      description: {
        fr: 'Expertise spécialisée dans l\'installation, la calibration et la maintenance de systèmes d\'instrumentation avancés pour le secteur Pétrole, Gaz et Industrie.',
        ar: 'خبرة متخصصة في تركيب ومعايرة وصيانة أنظمة القياس المتقدمة لقطاع النفط والغاز والصناعة.'
      },
      percentage: 95,
      color: '#FF6B00'
    },
    {
      title: {
        fr: 'Débitmètres à ultrasons',
        ar: 'مقاييس التدفق بالموجات فوق الصوتية'
      },
      description: {
        fr: 'Installation et calibration de précision des débitmètres à ultrasons Panametrics pour des mesures de débit non intrusives et de haute précision.',
        ar: 'تركيب ومعايرة دقيقة لعدادات التدفق بالموجات فوق الصوتية من Panametrics للحصول على قياسات تدفق غير متداخلة وعالية الدقة.'
      },
      percentage: 98,
      color: '#3182CE'
    },
    {
      title: {
        fr: 'Analyse de gaz',
        ar: 'تحليل الغاز'
      },
      description: {
        fr: 'Configuration et maintenance de systèmes d\'analyse de gaz pour la surveillance précise de la composition des gaz dans les environnements industriels.',
        ar: 'إعداد وصيانة أنظمة تحليل الغاز للمراقبة الدقيقة لتكوين الغاز في البيئات الصناعية.'
      },
      percentage: 92,
      color: '#805AD5'
    },
    {
      title: {
        fr: 'Analyse d\'humidité',
        ar: 'تحليل الرطوبة'
      },
      description: {
        fr: 'Déploiement et calibration d\'analyseurs d\'humidité pour la mesure précise du point de rosée et de la teneur en humidité dans les gaz et liquides.',
        ar: 'نشر ومعايرة محللات الرطوبة لقياس دقيق لنقطة الندى ومحتوى الرطوبة في الغازات والسوائل.'
      },
      percentage: 94,
      color: '#38A169'
    }
  ];
  
  const certifications = [
    {
      title: {
              fr: 'Certification Qualité',
      ar: 'شهادة الجودة'
      },
      description: {
        fr: 'Certification en sécurité, santé et environnement pour les opérations sur les sites Pétrole, Gaz et Industrie.',
        ar: 'شهادة في السلامة والصحة والبيئة للعمليات في مواقع النفط والغاز والصناعة.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      title: {
        fr: 'Certification Panametrics',
        ar: 'شهادة Panametrics'
      },
      description: {
        fr: 'Partenaire certifié pour l\'installation et la maintenance des produits Panametrics.',
        ar: 'شريك معتمد لتركيب وصيانة منتجات Panametrics.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      )
    },
    {
      title: {
        fr: 'ISO 9001:2015',
        ar: 'ISO 9001:2015'
      },
      description: {
        fr: 'Certification de système de gestion de la qualité pour des services cohérents et de haute qualité.',
        ar: 'شهادة نظام إدارة الجودة للخدمات المتسقة وعالية الجودة.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: {
        fr: 'Formation continue',
        ar: 'التدريب المستمر'
      },
      description: {
        fr: 'Engagement envers la formation continue et la mise à jour des connaissances techniques de notre équipe.',
        ar: 'الالتزام بالتدريب المستمر وتحديث المعرفة التقنية لفريقنا.'
      },
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path d="M12 14l9-5-9-5-9 5 9 5z" />
          <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 14l9-5-9-5-9 5 9 5z" />
        </svg>
      )
    }
  ];

  return (
    <section className="section" style={{ 
      backgroundColor: 'var(--assco-gray-50)',
      padding: '5rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Enhanced Decorative patterns */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FF6B00' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        opacity: 0.4
      }}></div>
      
      {/* Additional decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '5%',
        width: '200px',
        height: '200px',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.08) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '15%',
        left: '3%',
        width: '150px',
        height: '150px',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.06) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ 
        position: 'relative',
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        {/* Section header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.75rem 2rem',
            background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0.05) 100%)',
            color: 'var(--assco-orange)',
            borderRadius: '50px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1.5rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            border: '1px solid rgba(255, 107, 0, 0.1)'
          }}>
            {language === 'fr' ? 'NOTRE EXPERTISE' : 
             language === 'ar' ? 'خبرتنا' : 
             'OUR EXPERTISE'}
          </span>

          <h2 style={{
            fontSize: '3rem',
            fontWeight: '800',
            marginBottom: '1.5rem',
            color: '#1a202c',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Expertise technique spécialisée' : 
             language === 'ar' ? 'خبرة فنية متخصصة' : 
             'Specialized Technical Expertise'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100px',
              height: '4px',
              background: 'linear-gradient(90deg, var(--assco-orange) 0%, #FF8C42 100%)',
              borderRadius: '2px',
              boxShadow: '0 2px 10px rgba(255, 107, 0, 0.3)'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.25rem',
            color: '#4a5568',
            maxWidth: '800px',
            margin: '0 auto 4rem',
            lineHeight: '1.8'
          }}>
            {language === 'fr' 
              ? 'Notre équipe d\'experts possède une connaissance approfondie et une expérience étendue dans divers domaines d\'instrumentation pour le secteur Pétrole, Gaz et Industrie.' 
              : language === 'ar'
              ? 'يمتلك فريق الخبراء لدينا معرفة عميقة وخبرة واسعة في مختلف مجالات القياس لقطاع النفط والغاز والصناعة.'
              : 'Our team of experts has deep knowledge and extensive experience in various fields of instrumentation for the Oil, Gas and Industry sector.'}
          </p>
        </div>
        
        <div className="grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)',
          gap: '3rem',
          marginBottom: '4rem'
        }}>
          <div className="col-span-5 md-col-span-12">
            <div style={{
              backgroundColor: 'white',
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.08), 0 10px 25px -8px rgba(0, 0, 0, 0.04)',
              height: '100%',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              position: 'relative'
            }}>
              {/* Enhanced card decoration */}
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '150px',
                height: '150px',
                background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.06) 0%, transparent 70%)',
                borderRadius: '0 24px 0 100px'
              }}></div>
              
              <div style={{
                padding: '3rem 2.5rem 2rem',
                borderBottom: '1px solid #e2e8f0',
                position: 'relative',
                zIndex: 2
              }}>
                <h3 style={{
                  fontSize: '2rem',
                  fontWeight: '800',
                  marginBottom: '1rem',
                  color: '#1a202c',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '15px',
                    background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0.05) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid rgba(255, 107, 0, 0.1)'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '24px', height: '24px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  {language === 'fr' ? 'Certifications & Accréditations' : 
                   language === 'ar' ? 'الشهادات والاعتمادات' : 
                   'Certifications & Accreditations'}
                </h3>
                <p style={{
                  fontSize: '1.125rem',
                  color: '#4a5568',
                  lineHeight: '1.8',
                  marginBottom: '1.5rem'
                }}>
                  {language === 'fr' 
                    ? 'Notre équipe est certifiée selon les normes industrielles les plus strictes, garantissant un service de la plus haute qualité.' 
                    : language === 'ar'
                    ? 'فريقنا معتمد وفقًا لأعلى المعايير الصناعية، مما يضمن خدمة بأعلى جودة.'
                    : 'Our team is certified to the strictest industry standards, ensuring service of the highest quality.'}
                </p>
              </div>
              
              <div style={{
                padding: '2.5rem',
                position: 'relative',
                zIndex: 2
              }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '2rem'
                }}>
                  {certifications.map((cert, index) => (
                    <div 
                      key={index}
                      style={{
                        background: 'linear-gradient(135deg, var(--assco-gray-50) 0%, #fefefe 100%)',
                        padding: '2.5rem 2rem',
                        borderRadius: '20px',
                        height: '100%',
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        border: '1px solid rgba(255, 107, 0, 0.08)',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(255, 107, 0, 0.15)';
                        e.currentTarget.style.borderColor = 'rgba(255, 107, 0, 0.25)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.borderColor = 'rgba(255, 107, 0, 0.08)';
                      }}
                    >
                      {/* Small decorative element */}
                      <div style={{
                        position: 'absolute',
                        top: '1rem',
                        right: '1rem',
                        width: '50px',
                        height: '50px',
                        background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.06) 0%, transparent 70%)',
                        borderRadius: '50%'
                      }}></div>
                      
                      <div style={{
                        width: '60px',
                        height: '60px',
                        background: 'linear-gradient(135deg, var(--assco-orange) 0%, #FF8C42 100%)',
                        borderRadius: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '2rem',
                        color: 'white',
                        boxShadow: '0 10px 30px rgba(255, 107, 0, 0.3)',
                        position: 'relative',
                        zIndex: 2
                      }}>
                        <div style={{ width: '28px', height: '28px' }}>
                          {cert.icon}
                        </div>
                      </div>
                      
                      <h4 style={{
                        fontSize: '1.375rem',
                        fontWeight: '700',
                        marginBottom: '1.25rem',
                        color: '#2d3748',
                        position: 'relative',
                        zIndex: 2
                      }}>
                        {language === 'fr' ? cert.title.fr : 
                         language === 'ar' ? cert.title.ar : 
                         cert.title.fr}
                      </h4>
                      <p style={{
                        fontSize: '1rem',
                        color: '#4a5568',
                        lineHeight: '1.7',
                        position: 'relative',
                        zIndex: 2
                      }}>
                        {language === 'fr' ? cert.description.fr : 
                         language === 'ar' ? cert.description.ar : 
                         cert.description.fr}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-span-7 md-col-span-12">
            <div style={{
              backgroundColor: 'white',
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.08), 0 10px 25px -8px rgba(0, 0, 0, 0.04)',
              height: '100%',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              position: 'relative'
            }}>
              {/* Enhanced card decoration */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '150px',
                height: '150px',
                background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.06) 0%, transparent 70%)',
                borderRadius: '24px 0 100px 0'
              }}></div>
              
              <div style={{
                padding: '3rem 2.5rem 2rem',
                borderBottom: '1px solid #e2e8f0',
                position: 'relative',
                zIndex: 2
              }}>
                <h3 style={{
                  fontSize: '2rem',
                  fontWeight: '800',
                  marginBottom: '1rem',
                  color: '#1a202c',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '15px',
                    background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0.05) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid rgba(255, 107, 0, 0.1)'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '24px', height: '24px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  {language === 'fr' ? 'Domaines d\'expertise' : 
                   language === 'ar' ? 'مجالات الخبرة' : 
                   'Areas of Expertise'}
                </h3>
                <p style={{
                  fontSize: '1.125rem',
                  color: '#4a5568',
                  lineHeight: '1.8',
                  marginBottom: '1.5rem'
                }}>
                  {language === 'fr' 
                    ? 'Nos techniciens sont hautement qualifiés dans différents domaines de l\'instrumentation pour le secteur Pétrole, Gaz et Industrie, offrant une expertise spécialisée pour vos besoins spécifiques.' 
                    : language === 'ar'
                    ? 'فنيونا مؤهلون تأهيلاً عالياً في مختلف مجالات القياس لقطاع النفط والغاز والصناعة، ويقدمون خبرة متخصصة لاحتياجاتك المحددة.'
                    : 'Our technicians are highly skilled in different areas of instrumentation for the Oil, Gas and Industry sector, offering specialized expertise for your specific needs.'}
                </p>
              </div>
              
              <div style={{
                padding: '2.5rem',
                position: 'relative',
                zIndex: 2
              }}>
                {expertiseAreas.map((area, index) => (
                  <div 
                    key={index}
                    style={{
                      marginBottom: index < expertiseAreas.length - 1 ? '2.5rem' : '0'
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '1.25rem'
                    }}>
                      <h4 style={{
                        fontSize: '1.375rem',
                        fontWeight: '700',
                        color: '#2d3748'
                      }}>
                        {language === 'fr' ? area.title.fr : 
                         language === 'ar' ? area.title.ar : 
                         area.title.fr}
                      </h4>
                      <span style={{
                        fontSize: '1.25rem',
                        fontWeight: '800',
                        color: area.color,
                        textShadow: `0 0 20px ${area.color}40`
                      }}>
                        {area.percentage}%
                      </span>
                    </div>
                    
                    <div style={{
                      height: '14px',
                      backgroundColor: '#edf2f7',
                      borderRadius: '10px',
                      marginBottom: '1.75rem',
                      position: 'relative',
                      overflow: 'hidden',
                      boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.06)'
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: `${area.percentage}%`,
                        background: `linear-gradient(90deg, ${area.color} 0%, ${area.color}dd 100%)`,
                        borderRadius: '10px',
                        transition: 'width 1.5s ease-in-out',
                        boxShadow: `0 0 20px ${area.color}40`
                      }}></div>
                    </div>
                    
                    <p style={{
                      fontSize: '1.125rem',
                      color: '#4a5568',
                      lineHeight: '1.8'
                    }}>
                      {language === 'fr' ? area.description.fr : 
                       language === 'ar' ? area.description.ar : 
                       area.description.fr}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* Enhanced Call-to-Action Section */}
        <div style={{
          marginTop: '4rem',
          background: 'linear-gradient(135deg, var(--assco-orange) 0%, #FF8C42 100%)',
          borderRadius: '30px',
          padding: '4rem 3rem',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(255, 107, 0, 0.4)'
        }}>
          {/* Enhanced Decorative elements */}
          <div style={{
            position: 'absolute',
            top: '-50%',
            right: '-20%',
            width: '400px',
            height: '400px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.08)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '-30%',
            left: '-10%',
            width: '250px',
            height: '250px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.04)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: '20%',
            left: '10%',
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.06)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'relative',
            zIndex: 2
          }}>
            <h3 style={{
              fontSize: '2.5rem',
              fontWeight: '800',
              color: 'white',
              marginBottom: '1.5rem',
              textShadow: '0 4px 8px rgba(0,0,0,0.2)'
            }}>
              {language === 'fr' ? 'Besoin d\'une expertise technique spécialisée ?' : 
               language === 'ar' ? 'هل تحتاج إلى خبرة فنية متخصصة؟' : 
               'Need specialized technical expertise?'}
            </h3>
            
            <p style={{
              fontSize: '1.375rem',
              color: 'rgba(255, 255, 255, 0.9)',
              marginBottom: '2.5rem',
              maxWidth: '700px',
              margin: '0 auto 2.5rem'
            }}>
              {language === 'fr' ? 'Notre équipe certifiée est prête à vous accompagner dans tous vos projets d\'instrumentation.' : 
               language === 'ar' ? 'فريقنا المعتمد جاهز لمرافقتكم في جميع مشاريع القياس الخاصة بكم.' : 
               'Our certified team is ready to support you in all your instrumentation projects.'}
            </p>
            
            <div style={{
              display: 'flex',
              gap: '1.5rem',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button style={{
                backgroundColor: 'white',
                color: 'var(--assco-orange)',
                border: 'none',
                padding: '1.25rem 2.5rem',
                borderRadius: '50px',
                fontSize: '1.125rem',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
              }}>
                {language === 'fr' ? 'Contactez-nous' : 
                 language === 'ar' ? 'اتصل بنا' : 
                 'Contact Us'}
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }} viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              
              <button style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                padding: '1.25rem 2.5rem',
                borderRadius: '50px',
                fontSize: '1.125rem',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                e.currentTarget.style.transform = 'translateY(-3px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                {language === 'fr' ? 'Nos services' : 
                 language === 'ar' ? 'خدماتنا' : 
                 'Our Services'}
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Enhanced Mobile Styles */}
      <style jsx>{`
        @media (max-width: 768px) {
          .grid {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          
          .col-span-5, .col-span-7 {
            grid-column: span 12 / span 12 !important;
          }
        }
        
        .fade-in {
          opacity: 0;
          transform: translateY(30px);
          animation: fadeInUp 0.8s ease forwards;
        }
        
        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesExpertiseSection;